import { createNotesContextProvider } from 'src/SharedCommonContext/GenericNotesContextFactory';

export const {
  NotesProvider: ServiceRequestNotesProvider,
  useNotesDataFromContext: useServiceRequestNotesDataFromContext,
  useNotesActionsFromContext: useServiceRequestNotesActionsFromContext,
} = createNotesContextProvider({
  itemType: 'Service Request',
  displayName: 'service request',
});
